import type { DashboardDailyPoint } from '@gb-ticket/shared-types';

import { cn } from '@/lib/utils';

/** Compact dual-series bar chart (created vs closed) — no chart library. */
export function DashboardMiniBars({
  series,
  className,
}: {
  series: readonly DashboardDailyPoint[];
  className?: string;
}) {
  const max = Math.max(1, ...series.flatMap((point) => [point.created, point.closed]));

  return (
    <div className={cn('space-y-2', className)}>
      <div
        className="flex h-28 items-end gap-0.5 sm:gap-1"
        role="img"
        aria-label="Tickets erstellt und geschlossen der letzten Tage"
      >
        {series.map((point) => {
          const createdH = Math.round((point.created / max) * 100);
          const closedH = Math.round((point.closed / max) * 100);
          const dayLabel = point.date.slice(8);
          return (
            <div
              key={point.date}
              className="flex min-w-0 flex-1 flex-col items-center justify-end gap-0.5"
              title={`${point.date}: ${point.created} neu, ${point.closed} geschlossen`}
            >
              <div className="flex h-24 w-full items-end justify-center gap-px">
                <span
                  className="w-[45%] max-w-3 rounded-t-sm bg-primary"
                  style={{ height: `${Math.max(point.created > 0 ? 8 : 0, createdH)}%` }}
                />
                <span
                  className="w-[45%] max-w-3 rounded-t-sm bg-destructive"
                  style={{ height: `${Math.max(point.closed > 0 ? 8 : 0, closedH)}%` }}
                />
              </div>
              <span className="text-[10px] leading-none text-muted-foreground tabular-nums">
                {dayLabel}
              </span>
            </div>
          );
        })}
      </div>
      <div className="flex flex-wrap gap-3 text-xs text-muted-foreground">
        <span className="inline-flex items-center gap-1.5">
          <span className="size-2 rounded-sm bg-primary" aria-hidden />
          Neu
        </span>
        <span className="inline-flex items-center gap-1.5">
          <span className="size-2 rounded-sm bg-destructive" aria-hidden />
          Geschlossen
        </span>
      </div>
    </div>
  );
}
